import React from "react";
import { createPortal } from "react-dom";

const SettingsModal = ({
  title,
  description,
  children,
  onClose,
  panelClassName = "",
  bodyClassName = "",
}: {
  title: string;
  description: string;
  children: React.ReactNode;
  onClose: () => void;
  panelClassName?: string;
  bodyClassName?: string;
}) => {
  const hasCustomMaxWidth = panelClassName.includes("max-w-");

  const modalContent = (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/45 p-4">
      <div
        className={`max-h-[calc(100vh-2rem)] w-full ${
          hasCustomMaxWidth ? "" : "max-w-xl"
        } overflow-y-auto rounded-lg border border-gray-200 bg-white p-6 shadow-xl ${panelClassName}`}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="text-lg font-bold text-black">{title}</h3>
            <p className="mt-1 text-sm leading-6 text-black">{description}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-gray-200 text-sm font-bold text-gray-500 transition hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
            aria-label="Close modal"
          >
            X
          </button>
        </div>
        <div className={`mt-5 ${bodyClassName}`}>{children}</div>
      </div>
    </div>
  );

  if (typeof document === "undefined") {
    return modalContent;
  }

  return createPortal(modalContent, document.body);
};

export default SettingsModal;
